import { Helmet } from 'react-helmet';
import { getImageUrl } from '@/utils/images';
import { InsightCategoryType } from '@/queries/insights';

export const InsightsMeta = ({ currentTerm }: { currentTerm?: InsightCategoryType | null }) =>
    currentTerm ? (
        <Helmet>
            <title>{`${currentTerm.title} - Resurs Insights`}</title>
            <meta name="title" content={currentTerm?.meta_title || `${currentTerm.title} - Resurs Insights`} />
            <meta property="og:title" content={currentTerm?.meta_title || `${currentTerm.title} - Resurs Insights`} />
            {currentTerm?.meta_description && <meta name="description" content={currentTerm?.meta_description} />}
            {currentTerm?.meta_description && <meta property="og:description" content={currentTerm?.meta_description} />}
            {currentTerm?.featured_image?.src && <meta property="og:image" content={getImageUrl(currentTerm?.featured_image?.src)} />}
        </Helmet>
    ) : null;
